import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FileInfo, FileRestrictions, SelectEvent } from '@progress/kendo-angular-upload';

@Component({
    selector: 'import-file',
    templateUrl: './import-file.component.html',
    styleUrls: ['./import-file.component.scss']
})
export class ImportFileComponent {
    @Input() title: string = "Collection Note Upload";
    @Output() selected: EventEmitter<Array<FileInfo>> = new EventEmitter<Array<FileInfo>>();
    @Input() clearAfterSelect: boolean = true;
    @Input() disabled: boolean = false;
    files: Array<FileInfo> = [];
    uploadError: string;

    constructor() {

    }
    uploadRestrictions: FileRestrictions = {
        allowedExtensions: ['.xlsx', '.xls']
    };

    private validateFiles(event: SelectEvent): boolean {
        const invalidFile = event.files.find(file =>
            !this.uploadRestrictions.allowedExtensions.includes(file.extension)
        );

        if (invalidFile) {
            this.uploadError = `File type ${invalidFile.extension} is not allowed. Allowed types: ${this.uploadRestrictions.allowedExtensions.join(', ')}`;
            event.preventDefault();
            return false;
        }

        return true;
    }

    selectEventHandler(e: SelectEvent) {
        if (!this.validateFiles(e)) {
            return;
        }
        this.uploadError = "";
        this.files = e.files;
        this.selected.emit(this.files);
        if (this.clearAfterSelect) {
            this.clear();
        }
    }
    clear() {
        this.files = [];
    }
    completeEventHandler(e: any) {
        //noop
    }
}

